import { render, staticRenderFns } from "./BfCheckbox.vue?vue&type=template&id=14fc0eff&"
import script from "./BfCheckbox.vue?vue&type=script&lang=js&"
export * from "./BfCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BfCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports